import PolicyDetailsFrame from './PolicyDetailsFrame'

export default PolicyDetailsFrame
